export default __webpack_public_path__ + "1256ba6a26f0da4121e155cf536ef0c5.webp";